import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import AdminBaseForm from '../../../components/AdminBaseForm';
import { useBlueprintAdmin } from '../../../components/AdminProvider';
import { uiSchema } from '../../../forms/admins';
import { schema } from '../../../forms/userGroups';

const UserGroupEdit = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { config, adminUserApi } = useBlueprintAdmin();
  const [groups, setGroups] = useState([]);

  const onSuccess = (response) => {
    navigate(`/users/group/${response.data.id}`);
  };

  const onFailure = (data) => {
    console.error(data);
  };

  useEffect(() => {
    adminUserApi!
      .getGroups()
      .then(({ data }) => {
        if (data.length > 0) {
          const response = data.map((group) => ({
            type: 'string',
            enum: group,
            enumNames: group.name,
            title: group.name,
          }));
          setGroups(response);
        }
      })
      .catch((e) => console.error(e));
  }, []);

  return (
    <>
      {id && (
        <>
          <AdminBaseForm
            id={id}
            url='/admin/user-groups'
            entityTitle='User Group'
            schema={schema}
            uiSchema={uiSchema}
            onSuccess={onSuccess}
            onFailure={onFailure}
          />
        </>
      )}
    </>
  );
};

export default UserGroupEdit;
